@use "./avatar-overlay";

@layer base-components {
    .button {
        @include avatar-overlay.button;
    }
}
